export const childDailyAttendanceDTOFields = {
    child: 'child',
    attendance: 'attendance',
} as const;

export const specialChildDailyAttendanceDTOFields = {
    child: 'child',
    type: 'type',
} as const;
